import type { SVGProps } from 'react';

export const Copy = (props: SVGProps<SVGSVGElement>) => (
    <svg fill='currentColor' xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' {...props}>
        <path d='M20 6H8c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zm-1 14H9V8h10v12z' />
        <path d='M15 2H4c-.55 0-1 .45-1 1v13h2V4h10V2z' />
    </svg>
);
